import { ContentSection, ContentSectionGroup } from '@nrwl/rx-service-content-editor';
import { MemoizedSelector, createFeatureSelector, createSelector } from '@ngrx/store';
import { SearchModel, SearchType } from '@nrwl/rx-models';

import { ContentState } from './content.state';

const getError = (state: ContentState): any => state.error;

export const selectContentState = createFeatureSelector<ContentState>('content-editor');

export const getState = createSelector(selectContentState, (state) => state);

export const getRxCategories = createSelector(selectContentState, (state, props: any = null) => {
  if (props) {
    // Get search model of specific type
    const search = (state.search || []).find((model) => model.type === props.searchType);

    // Filter categories if searching
    if (search && search.keyword.length > 1) {
      if (!search.result) {
        return null;
      }

      // Return categories from found templates
      const filteredCategories = state.categories.filter((categ) => {
        return (
          categ.ofType(SearchType.RxLibrary) && search.result.categories.indexOf(+categ.id) > -1
          // categ.is_stock &&
          // !categ.is_published &&
          //categ.is_deleted === !!props.is_deleted
        );
      });

      // Update total templates counter per category
      const templatesFormModel: any = (state.search || []).find(
        (model: any) => model.type === props.searchType,
      );

      let foundTempaltes = [];

      if (templatesFormModel) {
        foundTempaltes = (search.result || {}).templates || [];
        filteredCategories.forEach((categ) => {
          // categ.forms_count = foundTempaltes.filter(
          //     templ => templ.category === categ.id
          // ).length;
        });
      }
      return filteredCategories;
    }
  }

  // Return all global categories
  return state.categories.filter((categ) => {
    return categ.is_stock && categ.ofType(state.leftViewMode);
  });
});

export const getGlobalCategories = createSelector(
  selectContentState,
  (state, props: any = null) => {
    if (props) {
      // Get search model of specific type
      const search: any = (state.search || []).find((model) => model.type === props.searchType);

      // Filter categories if searching
      if (search && search.keyword.length > 1) {
        if (!search.result) {
          return null;
        }

        return search.result.categories.filter((categ) => categ.ofType(SearchType.GlobalLibrary));

        // // Return categories from found templates
        // const filteredCategories = state.categories.filter(
        //     categ => {
        //         return (
        //             categ.is_stock &&
        //             search.result.categories.indexOf(+categ.id) > -1 &&
        //             categ.is_deleted === !!props.is_deleted
        //         );
        //     }
        // );
        //
        // // Update total templates counter per category
        // const templatesFormModel = (state.search || []).find(
        //     model => model.type === props.searchType
        // );
        //
        // let foundTempaltes = [];
        //
        // if (templatesFormModel) {
        //     foundTempaltes = (search.result || {}).templates || [];
        //     filteredCategories.forEach(categ => {
        //         // categ.forms_count = foundTempaltes.filter(
        //         //     templ => templ.category === categ.id
        //         // ).length;
        //     });
        // }
        // return filteredCategories;
      }
    }

    // Return all global categories
    return state.categories.filter((categ) => {
      return categ.ofType(SearchType.GlobalLibrary);
    });
  },
);

export const getAccountCategories = createSelector(
  selectContentState,
  (state, props: any = null) => {
    const search = (state.search || []).find((model) => model.type === props.searchType);

    // Filter categories if searching
    if (search && search.keyword.length > 1) {
      // Results not ready yet
      if (!search.result) {
        return null;
      }

      return search.result.categories.filter((categ) => {
        return !categ.is_stock && categ.ofType(state.rightViewMode);
      });

      // // Return categories to display
      // return state.categories.filter(categ => {
      //     return (
      //         categ.ofType(state.rightViewMode) &&
      //         search.result.categories.indexOf(categ.id) > -1
      //     );
      // });
    }

    // Return all account categories
    return state.categories.filter((categ) => {
      return !categ.is_stock && categ.ofType(state.rightViewMode);
    });
  },
);

export const getCategoryItems = createSelector(selectContentState, (state, props) => {
  if (!props) {
    return state.categoryItems;
  }

  let source = state.categoryItems;

  const search = (state.search || []).find((model) => model.type === props.searchType);

  if (search) {
    source = (search.result || {}).templates || [];
  }
  // Filter templates by category
  if (props && props.category) {
    const result = source.filter(
      (item: ContentSection) =>
        item.section_group === props.category.id && item.ofType(props.searchType),
    );
    return result;
  }
  return source;
});

export const getArchivedCategoryItemsForAL = createSelector(selectContentState, (state) => {
  let source = state.categoryItems;

  return source.filter((item) => {
    return item.is_deleted && item.is_published && !item.is_stock;
  });
});

export const getArchivedCategoryItemsForGL = createSelector(selectContentState, (state) => {
  let source = state.categoryItems;
  return source.filter((item) => {
    return item.is_deleted && item.is_published && item.is_stock;
  });
});

export const getSelectedCategoryItem = createSelector(selectContentState, (state) => {
  return state.selectedCategoryItem;
});

export const getSelectedPage = createSelector(selectContentState, (state) => {
  return state.selectedPage;
});

export const getMediaBuffer = createSelector(selectContentState, (state) => {
  return state.mediaDataObj;
});

export const getShowPreview = createSelector(selectContentState, (state) => {
  return state.showPreview;
});

export const getLeftViewMode = createSelector(selectContentState, (state) => {
  return state.leftViewMode;
});

export const getRightViewMode = createSelector(selectContentState, (state) => {
  return state.rightViewMode;
});

export const getSearchModel = createSelector(selectContentState, (state, props) => {
  if (state.search && props) {
    return state.search.find((model: SearchModel) => model.type === props.searchType);
  }
  return null;
});

export const getSelectedCategories = createSelector(selectContentState, (state, props = null) => {
  return state.selectedCategories;
});

export const getBusyCategories = createSelector(selectContentState, (state, props = null) => {
  return state.busyCategories;
});

export const getSectionPages = createSelector(selectContentState, (state, props = null) => {
  const result = state.sectionPages.filter((page) => page.section === state.selectedCategoryItemId);
  return result;
});

// select category item
// - load item
// - load pages
